import { Text, View } from "@react-pdf/renderer";
import i18n from "../../i18n";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableDataTableStyles } from "./DataTable";

export function DataTableFooter({ item, sumRsdi, lreq }) {
  let decimalSeparator = i18n.resolvedLanguage === "de-DE" ? "," : ".";
  let thousandSeparator = i18n.resolvedLanguage === "de-DE" ? "." : ",";
  let itemIndex = item.itemIndex;
  return (
    <View style={tableDataTableStyles.row} key={(itemIndex++).toString()}>
      {/* Title */}
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <p></p>
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={lreq}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={sumRsdi}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
    </View>
  );
}
